import { Controller } from "@hotwired/stimulus";
import { useOutlets } from "hb/insights/use_outlets"

export default class extends Controller {
  static targets = ["ball"]
  static values = { autostart: Boolean }

  connect() {
    this.mouseMoveHandler = this.handleMouseMove.bind(this)
    this.element.addEventListener('mousemove', this.mouseMoveHandler);

    this.lastMouseX = 0;
    this.lastMouseY = 0;
    this.dx = 0;
    this.dy = 0;
    this.maxSpeed = 3;
    this.speed = 2;

    useOutlets(this)

    if (this.autostartValue) this.start()
  }

  disconnect() {
    this.element.removeEventListener('mousemove', this.mouseMoveHandler);
  }

  handleMouseMove(event) {
    const rect = this.element.getBoundingClientRect();
    const mouseX = event.clientX - rect.left;
    const mouseY = event.clientY - rect.top;

    // Calculate the change in mouse position
    const newMouseDx = mouseX - (this.lastMouseX || mouseX);
    const newMouseDy = mouseY - (this.lastMouseY || mouseY);

    // Update the last mouse position
    this.lastMouseX = mouseX;
    this.lastMouseY = mouseY;

    // Apply a fraction of the mouse's velocity to the ball's velocity
    const fraction = 0.05;
    this.dx += newMouseDx * fraction;
    this.dy += newMouseDy * fraction;

    const velocityMagnitude = Math.sqrt(this.dx * this.dx + this.dy * this.dy);
    if (velocityMagnitude > this.maxSpeed) {
      const scale = this.maxSpeed / velocityMagnitude;
      this.dx *= scale;
      this.dy *= scale;
    }
  }

  start() {
    this.running = true
    this.element.classList.add('running');

    const container = this.element;
    const ball = this.ballTarget;
    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;
    const ballDiameter = ball.clientWidth;
    let x = Math.random() * (containerWidth - ballDiameter);
    let y = Math.random() * (containerHeight - ballDiameter);

    let angle = Math.random() * 2 * Math.PI;
    this.dx = Math.cos(angle) * this.speed;
    this.dy = Math.sin(angle) * this.speed;

    let moveBall = () => {
      if (!this.running)
        return

      x += this.dx;
      y += this.dy;

      if (x <= 0 || x >= containerWidth - ballDiameter) {
        this.dx = -this.dx;
      }
      if (y <= 0 || y >= containerHeight - ballDiameter) {
        this.dy = -this.dy;
      }

      ball.style.left = x + 'px';
      ball.style.top = y + 'px';

      this.loaderRunningId = requestAnimationFrame(moveBall);
    }

    moveBall();
  }

  stop() {
    this.element.classList.remove('running');
    this.running = false
    cancelAnimationFrame(this.loaderRunningId)
  }
}
